export default {
  selectAnOption: 'گزینه‌ای انتخاب کنید',
  addTitle: 'ایجاد',
  add(addPrefix: string | undefined, inputValue: string) {
    return `${addPrefix || this.addTitle} «${inputValue}»`;
  },
};
